import { useEffect } from "react";
import { Map } from "mapbox-gl";
import { Props } from "../NewProjectDeveloperMap";
import { getCameraFromUrl } from "../../NewProjectMap/Helpers/NewprojectMapHelpers";
import { deepClone } from "../../NewProjectMap/NewProjectHooks/hooksUtils";

export const useDeveloperMapPositionEffect = (
  map: React.MutableRefObject<Map | undefined>,
  props: Props,
  cameraString: string | undefined,
  prevProps: React.MutableRefObject<Props | undefined>,
  jumpToCoordinates: (coordinates: [number, number], customZoom?: number) => void,
  selectParcelIfAvailable: (position: [number, number]) => boolean
) => {
  useEffect(() => {
    if (!map.current) return;
    if (!prevProps.current) {
      prevProps.current = props;
      return;
    }

    const previousProps = deepClone(prevProps.current);
    prevProps.current = deepClone(props);

    const cameraFromUrl = getCameraFromUrl(cameraString);

    if (map.current && props.pinPosition && previousProps.pinPosition !== props.pinPosition) {
      if (!props.selectedFeature && !selectParcelIfAvailable(props.pinPosition)) {
        jumpToCoordinates(props.pinPosition);
      }
    } else if (previousProps.userLocation === undefined && props.userLocation && !cameraFromUrl) {
      jumpToCoordinates(props.userLocation);
    } else if (cameraFromUrl) {
      jumpToCoordinates(cameraFromUrl.center, cameraFromUrl.zoom);
    }
  }, [map.current, props.pinPosition, props.selectedFeature, props.userLocation]);
};
